import { axiosInstance, deleteAPI, getAPI, patchAPI, postAPI, putAPI } from '../utils/api';
import endpoints from '../utils/endpoints';

/**
 * 1. Admin Experience CRUD Actions
 */

export const getAdminExperiences = (params = {}, callback, errorCallback) => {
  return (dispatch) => {
    const queryParams = {
      page: params?.page ?? 0,
      size: params?.size ?? 20,
      ...(params?.search ? { search: params.search } : {}),
      ...(params?.category ? { category: params.category } : {}),
      ...(params?.city ? { city: params.city } : {}),
      ...(typeof params?.active === 'boolean' || params?.active === 'true' || params?.active === 'false'
        ? { active: params.active }
        : {}),
      ...(params?.minPrice !== undefined && params?.minPrice !== '' ? { minPrice: params.minPrice } : {}),
      ...(params?.maxPrice !== undefined && params?.maxPrice !== '' ? { maxPrice: params.maxPrice } : {}),
    };

    getAPI(
      endpoints.EXPERIENCES_ADMIN,
      queryParams,
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const getAdminExperienceById = (id, callback, errorCallback) => {
  return (dispatch) => {
    const url = endpoints.EXPERIENCE_ADMIN_BY_ID.replace(':id', id);
    getAPI(
      url,
      {},
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const createExperience = (payload, isMultipart = false, callback, errorCallback) => {
  return (dispatch) => {
    const token = localStorage.getItem('token');
    if (isMultipart || payload instanceof FormData) {
      axiosInstance
        .post(endpoints.EXPERIENCES_ADMIN, payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          withCredentials: true,
        })
        .then((res) => {
          if (typeof callback === 'function') callback(res);
        })
        .catch((err) => {
          if (typeof errorCallback === 'function') errorCallback(err);
        });
    } else {
      postAPI(
        endpoints.EXPERIENCES_ADMIN,
        payload,
        (res) => {
          if (typeof callback === 'function') callback(res);
        },
        (err) => {
          if (typeof errorCallback === 'function') errorCallback(err);
        },
        token
      );
    }
  };
};

export const updateExperience = (id, payload, isMultipart = false, callback, errorCallback) => {
  return (dispatch) => {
    const token = localStorage.getItem('token');
    const url = endpoints.EXPERIENCE_ADMIN_BY_ID.replace(':id', id);
    if (isMultipart || payload instanceof FormData) {
      axiosInstance
        .put(url, payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          withCredentials: true,
        })
        .then((res) => {
          if (typeof callback === 'function') callback(res);
        })
        .catch((err) => {
          if (typeof errorCallback === 'function') errorCallback(err);
        });
    } else {
      putAPI(
        url,
        payload,
        (res) => {
          if (typeof callback === 'function') callback(res);
        },
        (err) => {
          if (typeof errorCallback === 'function') errorCallback(err);
        },
        token
      );
    }
  };
};

export const deleteExperience = (id, callback, errorCallback) => {
  return (dispatch) => {
    const url = endpoints.EXPERIENCE_ADMIN_BY_ID.replace(':id', id);
    deleteAPI(
      url,
      {},
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const toggleExperienceStatus = (id, active, callback, errorCallback) => {
  return (dispatch) => {
    const url = `${endpoints.EXPERIENCE_ADMIN_STATUS.replace(':id', id)}?active=${Boolean(active)}`;
    patchAPI(
      url,
      {},
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

/**
 * 2. Public / Catalog Browsing Actions
 */

export const getPublicExperiences = (params = {}, callback, errorCallback) => {
  return (dispatch) => {
    const queryParams = {
      page: params?.page ?? 0,
      size: params?.size ?? 12,
      ...(params?.search ? { search: params.search } : {}),
      ...(params?.category ? { category: params.category } : {}),
      ...(params?.city ? { city: params.city } : {}),
      ...(params?.minPrice !== undefined && params?.minPrice !== '' ? { minPrice: params.minPrice } : {}),
      ...(params?.maxPrice !== undefined && params?.maxPrice !== '' ? { maxPrice: params.maxPrice } : {}),
    };

    getAPI(
      endpoints.EXPERIENCES_PUBLIC,
      queryParams,
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      }
    );
  };
};

export const getPublicExperienceById = (id, callback, errorCallback) => {
  return (dispatch) => {
    const url = endpoints.EXPERIENCE_PUBLIC_BY_ID.replace(':id', id);
    getAPI(
      url,
      {},
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      }
    );
  };
};

/**
 * 3. Experience Orders Lifecycle Actions
 */

export const getAdminExperienceOrders = (params = {}, callback, errorCallback) => {
  return (dispatch) => {
    const queryParams = {
      page: params?.page ?? 0,
      size: params?.size ?? 20,
      ...(params?.orderStatus ? { orderStatus: params.orderStatus } : {}),
      ...(params?.paymentStatus ? { paymentStatus: params.paymentStatus } : {}),
      ...(params?.category ? { category: params.category } : {}),
      ...(params?.search ? { search: params.search } : {}),
      ...(params?.from ? { from: params.from } : {}),
      ...(params?.to ? { to: params.to } : {}),
    };

    getAPI(
      endpoints.EXPERIENCE_ORDERS_ADMIN,
      queryParams,
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const getAdminExperienceOrderById = (id, callback, errorCallback) => {
  return (dispatch) => {
    const url = endpoints.EXPERIENCE_ORDER_ADMIN_BY_ID.replace(':id', id);
    getAPI(
      url,
      {},
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const updateExperienceOrderStatus = (id, payload, callback, errorCallback) => {
  return (dispatch) => {
    const url = endpoints.EXPERIENCE_ORDER_ADMIN_STATUS.replace(':id', id);
    patchAPI(
      url,
      payload,
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const confirmExperienceOrderAdmin = (id, payload = {}, callback, errorCallback) => {
  return (dispatch) => {
    const url = endpoints.EXPERIENCE_ORDER_ADMIN_CONFIRM.replace(':id', id);
    postAPI(
      url,
      payload,
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const createExperienceOrder = (payload, callback, errorCallback) => {
  return (dispatch) => {
    postAPI(
      endpoints.EXPERIENCE_ORDERS_CREATE,
      payload,
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const getMyExperienceOrders = (params = {}, callback, errorCallback) => {
  return (dispatch) => {
    getAPI(
      endpoints.EXPERIENCE_ORDERS_MY,
      params,
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const getExperienceOrderUserById = (id, callback, errorCallback) => {
  return (dispatch) => {
    const url = endpoints.EXPERIENCE_ORDER_PUBLIC_BY_ID.replace(':id', id);
    getAPI(
      url,
      {},
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const confirmExperienceOrderUser = (id, payload = {}, callback, errorCallback) => {
  return (dispatch) => {
    const url = endpoints.EXPERIENCE_ORDER_CONFIRM.replace(':id', id);
    postAPI(
      url,
      payload,
      (res) => {
        if (typeof callback === 'function') callback(res);
      },
      (err) => {
        if (typeof errorCallback === 'function') errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};
